import { render, staticRenderFns } from "./repairTypeUserList.vue?vue&type=template&id=48c36e8f&scoped=true"
import script from "./repairTypeUserList.vue?vue&type=script&lang=js"
export * from "./repairTypeUserList.vue?vue&type=script&lang=js"
import style0 from "./repairTypeUserList.vue?vue&type=style&index=0&id=48c36e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c36e8f",
  null
  
)

export default component.exports